import { render, staticRenderFns } from "./Bulletinboard.vue?vue&type=template&id=32442a06&scoped=true&"
import script from "./Bulletinboard.vue?vue&type=script&lang=js&"
export * from "./Bulletinboard.vue?vue&type=script&lang=js&"
import style0 from "./Bulletinboard.vue?vue&type=style&index=0&id=32442a06&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32442a06",
  null
  
)

export default component.exports